import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';

// Global Alert & Confirm overrides to prevent browser "localhost says" popups
if (typeof window !== 'undefined') {
  window.alert = (msg) => {
    const event = new CustomEvent('sim-alert', { detail: msg });
    window.dispatchEvent(event);
  };
  window.confirm = (msg) => {
    const event = new CustomEvent('sim-alert', { detail: `Action Confirmed: ${msg}` });
    window.dispatchEvent(event);
    return true;
  };
}

const SimulationsPage = lazy(() => import('./pages/SimulationsPage'));
const GymSimulationPage = lazy(() => import('./pages/GymSimulationPage'));
const NutraSimulationPage = lazy(() => import('./pages/NutraSimulationPage'));
const PosSimulationPage = lazy(() => import('./pages/PosSimulationPage'));
const SfaSimulationPage = lazy(() => import('./pages/SfaSimulationPage'));
const RealEstateSimulationPage = lazy(() => import('./pages/RealEstateSimulationPage'));
const RealEstateAppSimulationPage = lazy(() => import('./pages/RealEstateAppSimulationPage'));
const BarberAppSimulationPage = lazy(() => import('./pages/BarberAppSimulationPage'));

function AppContent() {
  const location = useLocation();
  const isSimulationDetail = location.pathname.startsWith('/simulations/') && location.pathname !== '/simulations';

  return (
    <div className={`bg-[#fcfcfc] text-[#0f172a] font-sans flex flex-col justify-between ${isSimulationDetail ? 'h-screen overflow-hidden' : 'min-h-screen'}`}>
      {!isSimulationDetail && <Navbar />}
      <main className={`grow ${isSimulationDetail ? 'h-full overflow-hidden' : ''}`}>
        <Suspense fallback={
          <div className="min-h-[60vh] flex items-center justify-center">
            <div className="w-8 h-8 rounded-full border-4 border-emerald-500 border-t-transparent animate-spin"></div>
          </div>
        }>
          <Routes>
            <Route path="/" element={<SimulationsPage />} />
            <Route path="/simulations" element={<SimulationsPage />} />
            <Route path="/simulations/gym" element={<GymSimulationPage />} />
            <Route path="/simulations/nutra" element={<NutraSimulationPage />} />
            <Route path="/simulations/pos" element={<PosSimulationPage />} />
            <Route path="/simulations/sfa" element={<SfaSimulationPage />} />
            <Route path="/simulations/realestate" element={<RealEstateSimulationPage />} />
            <Route path="/simulations/realestate-app" element={<RealEstateAppSimulationPage />} />
            <Route path="/simulations/barber-app" element={<BarberAppSimulationPage />} />
            <Route path="*" element={<Navigate to="/simulations" replace />} />
          </Routes>
        </Suspense>
      </main>
      {!isSimulationDetail && <Footer />}
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
